export default "__VITE_PUBLIC_ASSET__f43c31b4__"